<template>
  <div
    :style="{
      ...containerStyle,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    }"
  >
    <!-- สำหรับทำ BG -->
    <div
      :style="{
        ...containerBgStyle,
        position: 'absolute',
        zIndex: 0,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundPositionX: 'center',
      }"
    ></div>

    <!-- Float -->
    <!-- Top -->
    <FloatTop
      v-if="isShowFloatTop"
      pageName="MicrositeHistoryCode"
      :campaign="campaign"
      :isShowRedirectHome="isShowFloatTop"
    />
    <!-- Bottom -->
    <FloatBottom pageName="MicrositeHistoryCode" :campaign="campaign" />

    <Survey
      v-if="survey"
      :survey="survey"
      style="height: fit-content; z-index: 1"
      :style="{
        paddingTop: isShowFloatTop ? '52px' : '0px',
      }"
    ></Survey>

    <div class="w-100 d-flex justify-center pa-6">
      <v-card
        class="w-100 d-flex flex-column justify-center align-center table-show"
        style="padding: 24px 0px; z-index: 1"
        rounded="xl"
      >
        <h2 class="text-center font-weight-medium">
          {{ $t("microsite.textHistory") }}
        </h2>

        <v-card
          class="table-container mx-auto mt-4"
          rounded="lg"
          flat
          color="transparent"
        >
          <v-simple-table
            data-testid="table-transaction-history"
            class="mx-auto"
          >
            <thead class="text-center">
              <tr>
                <th class="text-center">{{ $t("microsite.textNo") }}</th>
                <th class="text-center">{{ $t("microsite.textCode") }}</th>
                <th class="text-center">{{ $t("microsite.point") }}</th>
                <th class="text-center">{{ $t("microsite.createdAt") }}</th>
                <th class="text-center">{{ $t("microsite.status") }}</th>
              </tr>
            </thead>

            <tbody class="text-center">
              <tr v-for="(item, index) in history" :key="index" class="pa-2">
                <td class="text-center">{{ index + 1 }}</td>
                <td class="text-center">{{ item.order_id }}</td>
                <td class="text-center">{{ item.point }}</td>

                <td class="text-center">{{ item.created_at | formatDate }}</td>
                <td class="text-center">
                  <v-chip :color="getStatusColor(item.status_detail)" small>
                    {{ getTextStatus(item.status_detail) }}
                  </v-chip>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card>

        <div>
          <v-btn
            data-testid="btn-back"
            color="black"
            class="text-center white--text mt-8"
            width="100"
            height="40"
            rounded
            @click="handleRedirectMenu"
          >
            {{ $t("microsite.textBack") }}
          </v-btn>
        </div>
      </v-card>
    </div>

    <v-footer padless v-if="campaign.is_show_footer">
      <v-col class="text-center footer" cols="12">
        <p class="ql-editor" v-html="campaign.footer_text"></p>
      </v-col>
    </v-footer>
  </div>
</template>

<script>
import moment from "moment";
import { Model } from "survey-core";
import { mapState } from "vuex";
import { Survey } from "survey-vue-ui";
import "survey-vue/defaultV2.min.css";
import MicrositeAxios from "@/config/microsite-service";
import {
  addClassQlEditorToSDDisplay,
  customThemeSurveyJS,
} from "../../../config/general-function";
import FloatTop from "./components/float-top.vue";
import FloatBottom from "./components/float-bottom.vue";

// moment.locale("en");

export default {
  name: "MicrositeHistoryCode",
  inject: ["isAppLoading"],
  components: {
    Survey,
    FloatTop,
    FloatBottom,
  },
  data: () => ({
    campaign: {
      is_show_footer: false,
    },
    survey: null,
    themeJson: null,
    history: null,
    logoHeight: null,
    containerStyle: {
      background: "#FFFFFF",
    },
    containerBgStyle: {
      background: "#FFFFFF",
    },

    isHoverableDevice: false,
    activeFloat: null,
    secondClick: false,
  }),
  async created() {
    await this.getCampaign();
    await this.getHistorySurveyAndTheme();
    this.getHistoryCode();

    this.survey = new Model(this.historySurveyJson);
    this.survey.applyTheme(this.themeJson);
    this.survey.showCompletedPage = false;
    this.setLogoHeight();
    // ========== ========== ========== ==========
    addClassQlEditorToSDDisplay();
  },
  computed: {
    ...mapState("microsite", ["user"]),
    ...mapState("defaultSystem", ["site"]),
    isShowFloatTop() {
      let check = false;
      const token = localStorage.getItem("token");
      const is_sync_customer = this.campaign?.is_sync_customer;
      if (token && is_sync_customer) {
        check = true;
      }
      return check;
    },
  },
  methods: {
    handleRedirectMenu() {
      this.$router.push({
        name: "microsite-menu",
        params: { id: this.$route.params.id },
      });
    },
    async getCampaign() {
      try {
        const response = await MicrositeAxios.get(
          `getCampaign/${this.site.id}?slug=${this.$route.params.slug}`
        );

        this.campaign = response.data.data.microsite;
      } catch (error) {
        console.log(error);
        this.$router.push({
          name: "microsite-error",
          params: { slug: this.$route.params.slug },
        });
      }
    },
    async getHistoryCode() {
      try {
        const response = await MicrositeAxios.get(
          `getHistoryCode/${this.campaign.id}?phone=${encodeURIComponent(
            this.user.phone
          )}`
        );

        const userExists = response.data.data.users;
        if (userExists) {
          this.$store.commit("microsite/SET_USER", {
            user: {
              phone: userExists ? userExists.phone : this.user.phone,
              fullname: userExists ? userExists.fullname : null,
              line_id: userExists ? userExists.line_id : null,
              detail: userExists ? userExists.detail : null,
              history: userExists ? userExists.campaignTransaction : null,
            },
          });
          this.history = userExists ? userExists.campaignTransaction : [];
        } else {
          this.$swal
            .fire({
              icon: "error",
              title: this.$t("microsite.dataNotFound"),
              showConfirmButton: true,
            })
            .then(() => {
              this.$router.push({ name: "microsite-login" });
            });
        }
      } catch (error) {
        this.$swal
          .fire({
            icon: "error",
            title: this.$t("microsite.errGeneral"),
            showConfirmButton: true,
          })
          .then(() => {
            this.$router.push({ name: "microsite-login" });
          });
        console.log(error);
      }
    },
    getHistorySurveyAndTheme() {
      const surveyJson = JSON.parse(this.campaign.survey_json);
      if (surveyJson && surveyJson.history) {
        this.historySurveyJson = surveyJson.history;
      } else {
        this.historySurveyJson = JSON.parse(
          this.campaign.template.default_survey_json
        ).history;
      }

      this.containerStyle = {
        backgroundColor: "#F3F3F3",
      };
      this.containerBgStyle = {
        backgroundColor: "#F3F3F3",
      };
      const themeJson = JSON.parse(this.campaign.theme_json);
      if (themeJson) {
        if (themeJson?.cssVariables) {
          const themeList = Object.keys(themeJson?.cssVariables);
          const _bg = themeList.find((x) => x == "--sjs-general-backcolor-dim");
          if (_bg) {
            this.containerStyle = {
              backgroundColor: themeJson?.cssVariables[_bg],
            };
            this.containerBgStyle = {
              backgroundColor: themeJson?.cssVariables[_bg],
            };
            if (themeJson?.backgroundImage) {
              this.containerBgStyle = {
                ...this.containerBgStyle,
                backgroundImage: `url(${themeJson.backgroundImage}`,
                backgroundSize: themeJson.backgroundImageFit,
                backgroundAttachment: themeJson.backgroundImageAttachment,
                opacity: themeJson.backgroundOpacity,
              };
              themeJson.backgroundImage = null;
              themeJson.cssVariables["--sjs-general-backcolor-dim"] =
                "transperent";
            }
          }
        }
        customThemeSurveyJS(themeJson?.cssVariables);
        this.themeJson = themeJson;
      }
    },
    getStatusColor(status) {
      if (status === "Success") {
        return "success";
      } else if (status === "Not found") {
        return "error";
      } else {
        return "warning";
      }
    },
    getTextStatus(status) {
      if (status === "Success") {
        return this.$t("microsite.textSuccess");
      } else if (status === "Not found") {
        return this.$t("microsite.textNotFound");
      } else {
        return this.$t("microsite.textUsed");
      }
    },
    handleClickStatus(data) {
      this.dialogs.detail = true;
      this.selectedTransaction = data;
    },
    getColor(status) {
      if (status === "Approved") {
        return "green";
      } else if (status === "Rejected") {
        return "red";
      } else {
        return "warning";
      }
    },

    setLogoHeight() {
      this.survey.onAfterRenderQuestion.add((_sender, options) => {
        if (options.question.name === "logo") {
          const imageElement =
            options.htmlElement.querySelector(".sd-image__image");
          if (imageElement) {
            const setHeight = () => {
              const height = imageElement.getBoundingClientRect().height;
              this.logoHeight = height + 30;
            };

            if (imageElement.complete) {
              setHeight();
            } else {
              imageElement.addEventListener("load", setHeight);
            }
          }
        }
      });
    },
  },
  filters: {
    formatDate: function (value) {
      if (!value) return "-";
      const date = moment(value);
      let label = "";
      if (date.year() == moment().year()) {
        label = date.format("DD MMM, HH:mm:ss");
      } else {
        label = date.format("DD MMM YY, HH:mm:ss");
      }
      return label;
    },
    formatDataTable: function (value) {
      if (!value) return "-";
      return value;
    },
  },
};
</script>

<style scoped>
.table-container {
  width: 95%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.dialog-image {
  z-index: 1000;
}

::v-deep .footer p {
  margin-bottom: 0px !important;
}

/* default */
::v-deep .sd-body--empty {
  display: none;
}
::v-deep .sd-body.sd-body--static {
  padding-top: 0px !important;
}
::v-deep .sd-page {
  padding: 0px !important;
}
::v-deep #sv-nav-complete {
  width: 100%;
}
::v-deep .sd-navigation__complete-btn {
  width: 100%;
}
::v-deep .sd-html span {
  font-size: inherit; /* ใช้ขนาดตาม h1 */
  font-weight: inherit; /* ใช้น้ำหนักตัวอักษรตาม h1 */
}
::v-deep .sd-html h1 {
  line-height: 1.5 !important;
}
::v-deep .sd-html h2 {
  line-height: 1.5 !important;
}
::v-deep .sd-html h3 {
  line-height: 1.5 !important;
}
::v-deep .sd-html h4 {
  line-height: 1.5 !important;
}
/* add-on */
::v-deep .sd-body {
  padding-bottom: 0px !important;
}
::v-deep .sd-navigation__complete-btn {
  display: none;
}
::v-deep .sd-action-bar {
  display: none;
}
</style>

<style lang="scss" scoped>
::v-deep .sd-file__decorator {
  background-color: var(
    --sjs-editorpanel-backcolor,
    var(
      --sjs-editor-background,
      var(
        --sjs-general-backcolor-dim-light,
        var(--background-dim-light, #f9f9f9)
      )
    )
  );
  border-radius: var(
    --sjs-editorpanel-cornerRadius,
    var(--sjs-corner-radius, 4px)
  );
}
::v-deep .sd-row:first-of-type {
  width: calc(100% + (2 * (3 * (var(--sjs-base-unit, var(--base-unit, 8px))))));
  margin-left: calc(-1 * (3 * (var(--sjs-base-unit, var(--base-unit, 8px)))));
  margin-right: calc(-1 * (3 * (var(--sjs-base-unit, var(--base-unit, 8px)))));
}
::v-deep .sd-row:first-of-type :is(.sd-image__image:first-of-type) {
  border-radius: 0px;
}
.table-show {
  max-width: calc(90 * (var(--sjs-base-unit, var(--base-unit, 8px))));
}
</style>
